import styled from '@emotion/styled'
import { Button } from '@mui/material'
import React, { ChangeEvent, forwardRef } from 'react'

interface FileUploadButtonProps {
    onChange: (e: ChangeEvent) => void
    label: string
    disabled?: boolean
}

const VisuallyHiddenInput = styled('input')({
    clip: 'rect(0 0 0 0)',
    clipPath: 'inset(50%)',
    height: 1,
    overflow: 'hidden',
    position: 'absolute',
    bottom: 0,
    left: 0,
    whiteSpace: 'nowrap',
    width: 1,
})

const FileUploadButton = forwardRef<HTMLInputElement, FileUploadButtonProps>(
    ({ onChange, label, disabled }, ref) => (
        <Button
            component="label"
            role={undefined}
            tabIndex={-1}
            variant="text"
            disabled={disabled}
        >
            {label}
            <VisuallyHiddenInput type="file" onChange={onChange} ref={ref} />
        </Button>
    )
)

export default FileUploadButton
